class LabelRepel2D {
    constructor() {
        this._labels = new Map();
        this._labelBox = new Map();
    }

    addLabel(id) {
        if (this._labels.has(id)) {
            return;
        }

        this._labels.set(id, {
            position: null,
            push: { x: 0, y: 0 },
            midBox: { x: 0, y: 0, halfWidth: 0, halfHeight: 0 },
            push4: { negX: 0, negY: 0, posX: 0, posY: 0 },
        });
    }

    removeLabel(id) {
        if (!this._labels.has(id)) {
            return;
        }

        this._labels.delete(id);
    }

    hasLabel(id) {
        return this._labels.has(id);
    }

    setLabelBox(id, box) {
        const { min: { x: minX, y: minY }, max: { x: maxX, y: maxY } } = box;
        box = { min: { x: minX, y: minY }, max: { x: maxX, y: maxY } };
        this._labelBox.set(id, box);
    }

    removeLabelBox(id) {
        this._labelBox.delete(id);
    }

    setLabelPosition(id, position) {
        const data = this._labels.get(id);

        if (position) {
            const { x, y } = position;
            position = { x, y };
        } else {
            position = null;
        }

        data.position = position;
    }

    getLabelPush(id) {
        const { x, y } = this._labels.get(id).push;
        return { x, y };
    }

    calculate() {
        const labels = [];
        for (let [id, data] of this._labels) {
            const { position, push, midBox, push4 } = data;

            push.x = 0;
            push.y = 0;
            push4.negX = 0;
            push4.negY = 0;
            push4.posX = 0;
            push4.posY = 0;

            if (position !== null) {
                labels.push(id);

                const { x, y } = position;
                let minX = 0, minY = 0, maxX = 0, maxY = 0;
                if (this._labelBox.has(id)) {
                    ({ min: { x: minX, y: minY }, max: { x: maxX, y: maxY } } = this._labelBox.get(id));
                }

                midBox.x = x+(minX+maxX)*0.5;
                midBox.y = y+(minY+maxY)*0.5;
                midBox.halfWidth = (maxX-minX)*0.5;
                midBox.halfHeight = (maxY-minY)*0.5;
            }
        }

        let pushed = false;

        for (let i1 = 0; i1 < labels.length-1; i1++) {
            const id1 = labels[i1];
            const { midBox: box1, push4: push1 } = this._labels.get(id1);

            for (let i2 = i1+1; i2 < labels.length; i2++) {
                const id2 = labels[i2];
                const { midBox: box2, push4: push2 } = this._labels.get(id2);

                const distX = Math.abs(box2.x-box1.x);
                const distY = Math.abs(box2.y-box1.y);
                const colDistX = box1.halfWidth+box2.halfWidth;
                const colDistY = box1.halfHeight+box2.halfHeight;

                if (distX < colDistX && distY < colDistY) {
                    const pushX = (colDistX-distX)*0.5;
                    const pushY = (colDistY-distY)*0.5;

                    if (pushX < pushY) {
                        if (box1.x < box2.x) {
                            push1.negX = Math.max(push1.negX, pushX);
                            push2.posX = Math.max(push2.posX, pushX);
                        } else {
                            push1.posX = Math.max(push1.posX, pushX);
                            push2.negX = Math.max(push2.negX, pushX);
                        }
                    } else {
                        if (box1.y < box2.y) {
                            push1.negY = Math.max(push1.negY, pushY);
                            push2.posY = Math.max(push2.posY, pushY);
                        } else {
                            push1.posY = Math.max(push1.posY, pushY);
                            push2.negY = Math.max(push2.negY, pushY);
                        }
                    }

                    pushed = true;
                }
            }
        }

        for (let [id, { position, push, push4 }] of this._labels) {
            if (position !== null) {
                let { negX, negY, posX, posY } = push4;

                if (posX > negX) {
                    negX *= 0.5;
                } else {
                    posX *= 0.5;
                }

                if (posY > negY) {
                    negY *= 0.5;
                } else {
                    posY *= 0.5;
                }

                push.x = posX-negX;
                push.y = posY-negY;
            }
        }

        return pushed;
    }
}

export default LabelRepel2D;
